"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Feedback_1 = require("../../../Feedback");
var Input_1 = require("../../../Input");
/**
 * 共通確認用ダイアログ
 * @param modalProps モーダルのProps
 * @param buttons ok/cancelの各々にonClickとchildren(文言)を渡す
 * @param title モーダルのタイトル文言
 * @param content titleの下のモーダルのcontentNode
 */
var ConfirmationModal = function (props) {
    var title = props.title, content = props.content, buttons = props.buttons, argProps = __rest(props, ["title", "content", "buttons"]);
    var mdUp = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.up('md'); });
    return ((0, jsx_runtime_1.jsx)(Feedback_1.Modal, __assign({}, argProps, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                width: { xs: 300, md: 432 },
                px: { xs: 0, md: 4 },
                py: { xs: 0, md: 5 },
                boxSizing: 'border-box',
            }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h3", align: "center", sx: { lineHeight: '28px', mb: { xs: 2, md: 3 } }, children: title }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { mb: { xs: 6, md: 7 } }, children: content }), (0, jsx_runtime_1.jsx)(Input_1.ButtonSet, { variant: "vertical", size: "medium", primaryButton: (0, jsx_runtime_1.jsx)(material_1.Button
                    /**
                     * @todo [ClickUp] https://app.clickup.com/t/7e0v6q
                     * spサイズ時のボタンサイズ確認中、アイテム作成organisms作成時に一緒にfixさせる
                     */
                    , __assign({ 
                        /**
                         * @todo [ClickUp] https://app.clickup.com/t/7e0v6q
                         * spサイズ時のボタンサイズ確認中、アイテム作成organisms作成時に一緒にfixさせる
                         */
                        size: mdUp ? 'large' : 'medium' }, buttons.ok, { fullWidth: true })), secondaryButton: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "outlined", size: mdUp ? 'large' : 'medium' }, buttons.cancel, { fullWidth: true })) })] }) })));
};
exports.ConfirmationModal = ConfirmationModal;
